import getBankFromAccount from './getBankFromAccount';

export default function getBankNameFromAccount(account: string): string {
  return getBankFromAccount(account)?.name || '';
}
